module.exports = __webpack_public_path__ + "media/images/levelup_crown_gold-36cb79d3ae11f0e081b2e1e42d2fd09c.png";